import { render, staticRenderFns } from "./DmDashSummary.vue?vue&type=template&id=de04b68a&scoped=true&"
import script from "./DmDashSummary.vue?vue&type=script&lang=js&"
export * from "./DmDashSummary.vue?vue&type=script&lang=js&"
import style0 from "./DmDashSummary.vue?vue&type=style&index=0&id=de04b68a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de04b68a",
  null
  
)

export default component.exports